var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { t } from '@lingui/core/macro';
import { Trans } from '@lingui/react/macro';
import { Dialog, DialogHeader, DialogContent, DialogFooter, Alert, Button, Loader, Box, Typography, useToast, } from '@pocketlaw/tetris';
import { useSendSignRequestReminder } from './useSendSignRequestReminder';
export function ConfirmReminderDialog(props) {
    const { onClose } = props;
    const { addToast } = useToast();
    const [sendReminderToSignatories, { loading, error }] = useSendSignRequestReminder();
    const handleSubmit = () => __awaiter(this, void 0, void 0, function* () {
        try {
            yield sendReminderToSignatories();
            addToast({
                title: t({ comment: 'E-signing send reminder - toast message', message: 'Reminder sent' }),
                appearance: 'info',
            });
            onClose();
        }
        catch (_a) {
            addToast({
                title: t({
                    comment: 'E-signing send reminder error - toast message',
                    message: 'Error sending reminder',
                }),
                appearance: 'danger',
            });
        }
    });
    return (<Dialog size="sm" onClose={onClose}>
      <DialogHeader title={t({
            comment: 'E-signing send reminder dialog - title',
            message: 'Send reminder',
        })}/>
      <DialogContent>
        <Box flexDirection="column" gap="lg">
          <Typography>
            <Trans comment="E-signing send reminder dialog - message">
              A reminder to sign this document will be sent to every person that has not signed yet.
            </Trans>
          </Typography>
          {error && (<Alert appearance="danger" message={t({
                message: 'The reminder could not be sent. Please try again or wait a moment and try later.',
                comment: 'E-signing send reminder dialog - failed error message',
            })}/>)}
        </Box>
      </DialogContent>
      <DialogFooter>
        <Button type="button" appearance="secondary" size="small" disabled={loading} onClick={onClose}>
          <Trans comment="E-signing send reminder dialog - cancel button label">Cancel</Trans>
        </Button>
        <Button type="button" disabled={loading} size="small" onClick={handleSubmit}>
          {loading && <Loader />}
          <Trans comment="E-signing send reminder dialog - confirm button label">Send</Trans>
        </Button>
      </DialogFooter>
    </Dialog>);
}
